// #region Imports

// --- Angular
import { Injectable, OnDestroy } from '@angular/core';

// --- Rx
import { BehaviorSubject, Observable } from 'rxjs';

// --- HS Code
import { SurveyResponseModel } from 'src/app/models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export abstract class InvitationBaseService implements OnDestroy {

  protected _invitationSuccess$: BehaviorSubject<boolean | null>;
  get invitationSuccess$(): Observable<boolean | null> {
    return this._invitationSuccess$;
  }

  constructor() {
    this._invitationSuccess$ = new BehaviorSubject<boolean | null>(null);
  }

  ngOnDestroy(): void {
    this._invitationSuccess$.next(null);
  }

  abstract sendInvitations(surveyResponseModel: SurveyResponseModel): void;
}
